import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreditCardConversionComponent } from './credit-card-conversion.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: CreditCardConversionComponent
  }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class CreditCardConversionRoutingModule { }
